module.exports = __webpack_public_path__ + "img/47.4cd9049d.jpg";